/**
 * Copyright IBM Corp. 2022, 2026
 */

import { FlightIcon } from '@hashicorp/mds-react/components'
import LegacyImage from 'next/legacy/image'
import s from './person.module.css'

export default function Person({
	name,
	photo,
	initials = false,
	jobTitle,
	companyName,
	socialProfiles,
}) {
	return (
		<li className={s.person}>
			<div className={s.personPhotoRow}>
				<div className={s.personPhotoFrame}>
					{initials ? (
						<div className={s.personInitials}>
							<span className={s.personInitialsText}>{initials}</span>
						</div>
					) : (
						<LegacyImage
							src={photo.url}
							layout="fill"
							objectFit="cover"
							quality={100}
							alt={name}
						/>
					)}
				</div>
			</div>
			<div className={s.personDetailsRow}>
				<span className={s.name}>{name}</span>
				<span className={s.title}>
					{jobTitle}
					{companyName ? `, ${companyName}` : null}
				</span>
			</div>
			<ul className={s.socialLinks}>
				{socialProfiles.map(({ url, networkName }) => (
					<li key={url}>
						<a href={url} rel="noopener noreferrer" target="_blank">
							<FlightIcon
								className={s.socialIcon}
								name={networkName}
								color="#D0D2D5"
								size={24}
							/>
						</a>
					</li>
				))}
			</ul>
		</li>
	)
}
